import { SERVICE_FEE_RULES_PATH } from 'cpmWorkspaces/navigation';

module.exports = {
  path: SERVICE_FEE_RULES_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/WorkspaceServiceFeeRules'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/show/routes/serviceFeeRules/index.js